import React, { Component } from 'react';
import { Nav, NavLink, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import './styles.scss';

// import api from "../../api";
// import functions from "../../api/functions.js";

class ParadigmaHeaderMenuMobile extends Component {
	constructor(props) {
		super(props);
		let Menues = this.props.Menues;
		let IsMobile = this.props.IsMobile;
		let ViewMenu = this.props.ViewMenu;

		this.state = {
			Menues: (Menues ? Menues : []),
			IsMobile: IsMobile,
			ViewMenu: ViewMenu
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.Menues !== this.props.Menues) {
			this.setState(prevState => {
				prevState.Menues = nextProps.Menues;
				prevState.Menues.forEach(x=>x.open=false);
				return prevState;
			})
		}
	}

	static propTypes = {
		Menues: PropTypes.array,
		onMenuWillOpen: PropTypes.func,
		onMenuOpened: PropTypes.func,
		onMenuWillClose: PropTypes.func,
		onMenuClosed: PropTypes.func,
	}

	updateDropdown(i, show) {
		const { onMenuClosed, onMenuOpened, onMenuWillClose, onMenuWillOpen } = this.props;
		this.setState(prevState => {
			prevState.Menues.forEach((x,j)=>x.open = j==i ? show : false);
			if (show) {
				if (onMenuWillOpen) onMenuWillOpen();
			} else {
				if (onMenuWillClose) onMenuWillClose();
			}
			return prevState;
		}, () => {
			if (show) {
				if (onMenuOpened) onMenuOpened();
			} else {
				if (onMenuClosed) onMenuClosed();
			}
		});
	}


	preventDefault(e) {
		e = e || window.event;
		if (e.preventDefault)
			e.preventDefault();
		e.returnValue = false;
	}

	preventDefaultForScrollKeys(e) {
		let keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
		if (keys[e.keyCode]) {
			this.preventDefault(e);
			return false;
		}
	}

	disableScroll() {
		if (window.addEventListener) // older FF
			window.addEventListener('DOMMouseScroll', this.preventDefault, false);
		window.onwheel = this.preventDefault; // modern standard
		window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
		window.ontouchmove = this.preventDefault; // mobile
		document.onkeydown = this.preventDefaultForScrollKeys;
	}

	enableScroll() {
		if (window.removeEventListener)
			window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
		window.onmousewheel = document.onmousewheel = null;
		window.onwheel = null;
		window.ontouchmove = null;
		document.onkeydown = null;
	}

	generateSubMenu(y, i){

		// Esta parte solo ordena alfabeticamente los submenues.
		y.submenues.sort(function(a, b) {
			const nameA = a.Nombre.toUpperCase(); // ignore upper and lowercase
			const nameB = b.Nombre.toUpperCase(); // ignore upper and lowercase
			if (nameA > nameB) {
				return 1;
			}
			if (nameA < nameB) {
				return -1;
			}
			return 0;
		});
		// <----

		let elem = (
			<li key={i}>
			<a href={"/tienda/productos/" + (y.href)} className="title">{y.Nombre}</a>
			<nav>
				<ul>
					{
						(	
							y.submenues && y.submenues.length > 0 ?
							y.submenues.map((z, i) =>
								<li key={i}>
								<a href={"/tienda/productos/" + z.href}>{z.Nombre}</a>
								</li>
							)
							:
							null
						)
					}
				</ul>
			</nav>
			</li>
		);
		return elem;
	}

	generateMenu(x){
		let response = [];
		let chunks = (array,n) => array.map((x,i) => array.slice(i*n,i*n+n).length > 0 ? array.slice(i*n,i*n+n):null).filter(i=>i != null);
		
		//Esta parte solo ordena alfabeticamente los submenues.
		let sorted = x.submenues.map(x => x.Nombre).sort()
		let sortedSubMenues= []
		sorted.map(nombre => {
			let subMenu = {}
			subMenu = x.submenues.find(el => el.Nombre == nombre)
			sortedSubMenues.push(subMenu)
		})
		//-------

		chunks(sortedSubMenues, 5).forEach(
			chunk => {
				let resp = [];
				chunk.forEach((y,i)=>resp.push(this.generateSubMenu(y)));
				let elem = (
					// <Row className='px-3'>{ resp.map(item=><React.Fragment>{item}</React.Fragment>) }</Row>				
					resp.map(item=><React.Fragment>{item}</React.Fragment>)			
				);
				response.push(elem);
			}
		)
		return response;
	}

	render() {
		let { Menues } = this.state;
		if (Menues.filter(x => x.open).length) {
			this.disableScroll();
		} else {
			this.enableScroll();
		}

		return (
			<div className="subMenu subMenu__mobile d-flex d-lg-none">
				<Row>
					<Nav className="paradigma-header-menu paradigma-header-menu--mobile">
						{Menues.map((x, i) =>
							<li
								className="paradigma-header-menu-dropdown py-2"
								key={i}
								onMouseEnter={() => this.updateDropdown(i, true)}
								onMouseLeave={() => this.updateDropdown(i, false)}
								onClick={() => this.updateDropdown(i, !x.open)}
							>
							<BrowserView>
							<NavLink href={"/tienda/productos/" + x.href} className="paradigma-header-menu-button">{x.Nombre}</NavLink>
							</BrowserView>
							<MobileView>
							    {x.Nombre}
							</MobileView>
								<div
									className={"paradigma-header-menu-dropdown-menu " + (x.open ? "show" : "")}
									style={{ backgroundImage: "url(" + x.image + ")" }}
									onClick={
										(e) => {e.stopPropagation(); this.updateDropdown(i, true);}
									}
								>
									<div className="paradigma-header-menu-dropdown-menu-title">
										<h4 className='text-center'><a href={"/tienda/productos/" + x.href}>{x.Nombre}</a></h4>
									</div>
									<ul className="paradigma-header-menu-dropdown-menu-list menu-list__mobile">
										{
											(
												x.submenues && x.submenues.length > 0 ?
												this.generateMenu(x)
												:
												null
											)
										}
									</ul>
								</div>
							</li>
						)
						}
					</Nav>
				</Row>
			</div>
		)
	}
}

export default ParadigmaHeaderMenuMobile;
